import React from 'react'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'

class FoodPairingList extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            filters: {},
            foodPairings: {
                columns: [
                    {
                        label: 'Food pairing name in English',
                        key: 'nameEn'
                    },
                    {
                        label: 'Food pairing name in Chinese',
                        key: 'nameZh'
                    },
                    {
                        content: 'Edit',
                        action: 'edit',
                        className: 'edit-link',
                        onClick: (id, key) => {
                            this.props.history.push('/food-pairings/' + id + '/edit')
                        }
                    }],
                entities: [],
                filters: [],
                actions: [{
                    classList: 'blue add',
                    label: 'New food pairing',
                    onClick: () => this.props.history.push('/food-pairings/new')
                }],
                selectedItems: [],
                multiSelect: false,
            }
        }
    }

    componentDidMount() {
        API.getFoodPairings(this.state.filters).then(entities => {
            entities.forEach(entity => {
                if (entity.name) {
                    if (entity.name.en) {
                        entity.nameEn = entity.name.en
                    } else {
                        entity.nameEn = '-'
                    }

                    if (entity.name.zh) {
                        entity.nameZh = entity.name.zh
                    } else {
                        entity.nameZh = '-'
                    }
                }
            })

            this.setState({
                ...this.state,
                loading: false,
                foodPairings: {...this.state.foodPairings, entities: entities}
            })
        })
    }

    loadEntities() {
        API.getFoodPairings(this.state.filters).then(entities => {
            entities.forEach(entity => {
                if (entity.name) {
                    if (entity.name.en) {
                        entity.nameEn = entity.name.en
                    } else {
                        entity.nameEn = '-'
                    }

                    if (entity.name.zh) {
                        entity.nameZh = entity.name.zh
                    } else {
                        entity.nameZh = '-'
                    }
                }
            })

            this.setState({
                ...this.state,
                loading: false,
                foodPairings: {...this.state.foodPairings, entities: entities}
            })
        })
    }

    render() {
        if (this.state.loading)
            return <Loader/>
        else
            return <>
                <Head title={'Food Pairings'}/>
                <Content>
                    <Table settings={this.state.foodPairings}/>
                </Content>
            </>
    }
}

export default FoodPairingList
